<template>
	<div :class="['grid-container empty-state', `empty-state--${type}`]">
		<div class="grid-x grid-margin-x">
			<div class="cell small-12">
				<div class="empty-state__wrapper">
					<div class="empty-state__inner">
						<div class="grid-x grid-margin-x">
							<div class="cell small-12 medium-8 large-6">
								<h2
									v-if="heading"
									class="empty-state__heading"
									v-html="heading"
								></h2>
								<p
									v-if="preamble"
									class="empty-state__preamble"
									v-html="preamble"
								></p>
								<div class="empty-state__button">
									<a href="#" v-scroll-to="'#accommodation-search'">
										<Button v-if="type === 'accommodation'">
											{{ linktext }}
										</Button>
									</a>
								</div>
								<p
									v-if="bodytext"
									class="empty-state__bodytext"
									v-html="bodytext"
								></p>
							</div>
							<div
								v-if="$slots.rightBoxes"
								class="cell small-12 medium-12 large-6"
							>
								<div class="empty-state__right-boxes">
									<slot name="rightBoxes"></slot>
								</div>
							</div>
						</div>
					</div>
					<div v-if="$slots.bottomBoxes" class="empty-state__bottom-boxes">
						<slot name="bottomBoxes"></slot>
					</div>
				</div>
				<div v-if="type != 'accommodation'" class="empty-state__link">
					<button @click="scrollToTop()">{{ linktext }}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Button from '../atoms/Button'

export default {
	name: 'EmptyState',
	data: () => {
		return {}
	},
	components: {
		Button
	},
	props: {
		type: {
			type: String,
			default: ''
		},
		heading: {
			type: String,
			default: ''
		},
		preamble: {
			type: String,
			default: ''
		},
		bodytext: {
			type: String,
			default: ''
		},
		linktext: {
			type: String,
			default: ''
		}
	},
	methods: {
		scrollToTop() {
			window.scrollTo(0, 0)
		}
	}
}
</script>

<style scoped lang="scss">
.empty-state {
	background-size: 100% auto;
	background-repeat: no-repeat;
	margin-bottom: 60px;

	&__inner {
		background-size: cover;
		background-repeat: no-repeat;
		padding: 0 0 30px 0;
	}
	&__wrapper {
		background-size: 100% auto;
		background-repeat: no-repeat;
		padding: 30px 0 0;
		margin-top: 20px;
		@include for-tablet-portrait-up {
			padding: 30px 20px 0;
		}
	}
	&__right-boxes {
		margin-top: 30px;
	}

	&__heading {
		font-size: 28px;
		font-weight: 300;
		line-height: 1.1;
		text-align: center;
		margin-bottom: 30px;
		text-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
	}
	&__preamble {
		font-size: 14px;
		line-height: 1.5;
		text-align: center;
		margin-bottom: 70px;
		text-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
	}
	&__bodytext {
		font-size: 14px;
		line-height: 1.7;
		text-align: center;
	}
	&__button {
		text-align: center;
		margin-bottom: 20px;
	}
	&__link {
		margin-top: 90px;
		text-align: center;
		button {
			background: none;
			border: none;
			color: $colorSecondary;
			text-decoration: underline;
		}
	}

	&--accommodation {
		background-color: #546482;
		background-image: url('/images/accommodation-mobile.png');
		background-position: top left;
		margin-bottom: 120px;
		padding-top: 0!important;

		@include for-phone-only {
			margin-bottom: 0;
		}

		.empty-state__preamble {
			margin-bottom: 20px;
		}
		.empty-state__heading,
		.empty-state__preamble,
		.empty-state__bodytext {
			color: #fff;
		}
	}
	&--skipass {
		.empty-state__wrapper {
			background-color: #42aefd;
			background-image: url('/images/skipass-mobile.png');
			background-position: bottom center;
		}
		.empty-state__heading,
		.empty-state__preamble,
		.empty-state__bodytext {
			color: #434449;
		}
	}
	&--skirental {
		.empty-state__wrapper {
			background-color: #546482;
			background-image: url('/images/skirental-mobile.png');
			background-position: top left;
		}
		.empty-state__heading,
		.empty-state__preamble,
		.empty-state__bodytext {
			color: #fff;
		}
	}
	&--skischool {
		.empty-state__wrapper {
			background-color: #546482;
			background-image: url('/images/skischool-mobile.png');
			background-position: top left;
		}
		.empty-state__heading,
		.empty-state__preamble,
		.empty-state__bodytext {
			color: #fff;
		}
	}
	&--activities {
		.empty-state__wrapper {
			background-color: #546482;
			background-image: url('/images/activities-mobile.png');
			background-position: top left;
		}
		.empty-state__heading,
		.empty-state__preamble,
		.empty-state__bodytext {
			color: #fff;
		}
	}

	@media (min-width: 640px) {
		padding-top: 40px;

		&__inner {
			padding: 50px;
		}
		&__wrapper {
			padding: 0 0 30px;
		}
		&__right-boxes {
			margin-top: 30px;
		}
		&__bottom-boxes {
			margin-bottom: 0;
			padding: 0 50px;
		}

		&__heading {
			font-size: 36px;
			text-align: left;
			text-shadow: none;
		}
		&__preamble {
			font-size: 18px;
			text-align: left;
			text-shadow: none;
			margin-bottom: 30px;
		}
		&__bodytext {
			text-align: left;
		}
		&__link,
		&__button {
			display: none;
		}

		&--accommodation {
			background: none;
			.empty-state__inner {
				padding-bottom: 30px;
			}
			.empty-state__inner {
				background-image: url('/images/accommodation.png');
				background-position: top left;
			}
			.empty-state__wrapper {
				background-image: none;
				padding-bottom: 0;
			}
			.empty-state__right-boxes {
				margin-bottom: -90px;
			}
		}
		&--skipass {
			.empty-state__inner {
				padding-bottom: 30px;
			}
			.empty-state__inner {
				background-image: url('/images/skipass.png');
				background-position: bottom center;
			}
			.empty-state__wrapper {
				background-image: none;
				padding-bottom: 0;
			}
		}
		&--skirental {
			.empty-state__inner {
				padding-bottom: 170px;
			}
			.empty-state__bottom-boxes {
				margin-top: -110px;
			}
			.empty-state__inner {
				background-image: url('/images/skirental.png');
				background-position: top left;
			}
			.empty-state__wrapper {
				background-image: none;
			}
		}
		&--skischool {
			.empty-state__inner {
				padding-bottom: 270px;
			}
			.empty-state__bottom-boxes {
				margin-top: -210px;
			}
			.empty-state__inner {
				background-image: url('/images/skischool.png');
				background-position: top left;
			}
			.empty-state__wrapper {
				background-image: none;
			}
		}
		&--activities {
			.empty-state__inner {
				padding-bottom: 195px;
			}
			.empty-state__bottom-boxes {
				margin-top: -210px;
			}
			.empty-state__inner {
				background-image: url('/images/activities.png');
				background-position: center left;
			}
			.empty-state__wrapper {
				background-image: none;
			}
			.empty-state__heading {
				margin-top: 100px;
			}
		}
	}

	@media (min-width: 1024px) {
		&__right-boxes {
			margin-top: 0;
		}
		&--skipass {
			.empty-state__inner {
				padding-bottom: 210px;
				background-position: top left;
			}
		}
		&--accommodation {
			&__right-boxes {
				margin-bottom: -120px;
			}
		}
		&--accommodation,
		&--skirental,
		&--skischool,
		&--skipass,
		&--activities {
			.empty-state__wrapper {
				background: none;
			}
		}
	}
}
</style>
